import { useEffect, useRef, useState } from 'react';

/**
 * Skips transient intermediate values — defers state update to the next task (setTimeout 0),
 * so rapid changes within the same tick only trigger one re-render with the final settled value.
 */
export const useTransientState = <T>(value: T) => {
  const [state, setState] = useState(value);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    timerRef.current = setTimeout(() => setState(value), 0);
    return () => clearTimeout(timerRef.current);
  }, [value]);

  return { state };
};
